<template>
    <div>
        <div class="login app" id="login" :style="style" v-if="show">
            <div :class="loginClass ? loginClass : loginBox">
                <div class="logo" :style="this.$t('mainStyle.LOGO_WIDTH')">{{ $t(systemName) }}</div>
                <el-form :model="login" ref="login">
                    <el-form-item prop="username">
                        <input type="password" style="outline:none;border:0;width:0px;height:0px;background-color: rgba(0, 0, 0, 0);float:left;border-width:0;" />
                        <td-input v-model="login.username" class="login" :width="300" :placeholder="$t('component.USERNAME')"></td-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <td-input v-model="login.password" class="login" :width="300" @keyup.enter.native="BtnLogin" :placeholder="$t('component.PASSWORD')" type="password"></td-input>
                    </el-form-item>
                    <el-form-item style="padding-top:20px">
                        <td-checkbox v-model="rememberPw">{{ $t('component.REMBMBER_PASSWORD') }}</td-checkbox>
                        <slot name="login">
                            <td-button type="primary" round style="width:160px;margin-left:20px;" @click="BtnLogin()" :loading="buttonLoading" v-if="!buttonLoading">{{
                                $t('component.LOGIN')
                            }}</td-button>
                            <td-button type="primary" round style="width:160px;margin-left:20px;" :loading="buttonLoading" v-if="buttonLoading">{{ $t('component.LOGINLOADING') }}</td-button>
                        </slot>
                    </el-form-item>
                </el-form>
                <slot name="pluginSlot"></slot>
            </div>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        /* 背景名称 */
        backgroundName: {
            type: String,
            default: 'background.png'
        },
        /* 系统名称 */
        systemName: {
            type: String,
            default: window.config.systemName
        },
        /* 外部样式 */
        loginClass: String,
        /* 登录入口标识 */
        sPlatformFlg: {
            type: String,
            default: ''
        }
    },
    beforeDestroy() {},
    data() {
        return {
            buttonLoading: false,
            loginBox: 'loginBox',
            style: {
                backgroundImage: 'url(' + require('../../assets/images/' + this.backgroundName) + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%'
            },
            login: {
                username: '',
                password: '',
                currentToken: ''
            },
            url: '',
            data: '',
            show: false,
            initMenuData: [],
            rememberPw: false,
            /* 是否单点登录 */
            SSO: false,
            currentToken: ''
        };
    },
    mounted() {
        window.vue.$EventBus.$on('pluginLoadEnd', menu => {
            if (this.SSO) {
                window.app.sPlatformFlg = this.$util.getUrlKey('platformFlg');
                this.$userPwdLoginCheck.userPasswordLogin(this.login, function(val) {
                    if (val.ret) {
                        this.$systemUtil.initData();
                    }
                });
            }
        });
        /* 单点登录 */
        this.login.username = this.$util.getUrlKey('username');
        this.login.password = this.$util.getUrlKey('password');
        this.login.currentToken = this.$util.getUrlKey('token');
        if (this.login.currentToken || (this.$util.getUrlKey('username') && this.$util.getUrlKey('password'))) {
            this.SSO = true;
            this.show = false;
        } else {
            this.show = true;
            /* 记住密码功能 */
            this.rememberPw = this.$systemUtil.getCookieLoginInfo(this.login);
        }
    },
    methods: {
        /* 开始验证登录程序 */
        BtnLogin() {
            this.buttonLoading = true;
            let _this = this;
            this.$systemUtil.startLogin(this.login, function(callbackInfo) {
                if (callbackInfo.ret) {
                    _this.$systemUtil.initData('home');
                    _this.show = true;
                    _this.rememberPw = _this.$systemUtil.dealUserInfo(_this.login, _this.rememberPw);
                    //_this.initWebSocket();
                }
                _this.buttonLoading = false;
            });
        },
        //初始化tWebSocket
        initWebSocket() {
            if (!window.vue.$util.isEmpty(sessionStorage.getItem('socketInfo'))) {
                window.vue.$socketApi.close(JSON.parse(sessionStorage.getItem('socketInfo')).agentId);
            }
            let params = {
                sTag: 'Easy7WebSocketInfo'
            };
            let _this = this;
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                if (response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE && response.status === this.$common.login.RESPONSE_STATUS) {
                    let socketInfo = {
                        agentId: _this.$util.getUUID(),
                        token: sessionStorage.getItem('token'),
                        url: JSON.parse(response.data.content[0].sCode).url,
                        platform: JSON.parse(response.data.content[0].sCode).platform,
                        sender: 'platformClient',
                        cmd: 2,
                        clientlist: 'TerminalServer',
                        paramUrl: window.config.host + '/auth/authCtrl/login'
                    };
                    sessionStorage.setItem('socketInfo', JSON.stringify(socketInfo));
                    window.vue.$socketApi.initWebSocket(socketInfo);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                }
            });
        }
    }
};
</script>
<style scoped>
.login .el-input__inner {
    background: rgba(0, 0, 0, 0);
    border: 0px;
    border-bottom: 1px solid;
    font-size: 18px;
    color: white;
}
.logo {
    text-align: center;
    margin-bottom: 30px;
    font-size: 32px;
    color: #fdfdf1;
}
.loginBox {
    position: absolute;
    left: 50%;
    top: 53%;
    width: 600px;
    height: 350px;
    margin-top: -175px;
    margin-left: -300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 5px;
    text-align: center;
}
.login .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
}
.login .el-button--primary:hover {
    background-color: #66b1ff;
    border-color: #66b1ff;
}
.login .el-input__inner:hover {
    border: 0px;
    border-bottom: 1px solid;
}
</style>
